import { I18n } from '@calendly/i18n';
import { Avatar } from '@calendly/ui/components/avatar';
import { BareButton } from '@calendly/ui/components/bare-button';
import { FullStoryExclude, FullStoryMask } from '@calendly/ui/components/fullstory-privacy';
import { IconUsers } from '@calendly/ui/components/glyphs/IconUsers';
import { IconX } from '@calendly/ui/components/glyphs/IconX';
import { BodyText } from '@calendly/ui/components/typography';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1ewxjjd";
const Container = forwardRef((props, ref) => <div ref={ref} {...props} className={classNames(containerCss, props.className)} />);
const labelCss = "l1x78e14";
const removeButtonCss = "rnhmtxy";
const RecipientAvatar = ({
  recipient
}) => {
  if (recipient.subjectType === 'user_group') {
    return <UiIcon icon={IconUsers} size="small" color={colorTextSecondary} title="" />;
  }
  return <FullStoryExclude>
      <Avatar size="x-small" letter={recipient.display.avatarLetter} src={recipient.display.avatarUrl} />
    </FullStoryExclude>;
};
const getRecipientLabel = recipient => recipient.display.name || recipient.display.email;
export const RecipientChip = ({
  recipient,
  onRemove
}) => {
  const label = getRecipientLabel(recipient);
  return <Container data-testid={`recipient-chip-${recipient.id}`}>
      <RecipientAvatar recipient={recipient} />
      <BodyText size="small" className={labelCss}>
        <FullStoryMask>{label}</FullStoryMask>
      </BodyText>
      <BareButton className={removeButtonCss} aria-label={`${I18n.t('publisher.action.remove')} ${label}`} onClick={onRemove}>
        <UiIcon icon={IconX} size="small" title="" />
      </BareButton>
    </Container>;
};

require("./recipient_chip.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./recipient_chip.js");